import React from "react";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  classes = "",
  parentClasses = "",
  disabled = false,
  required = false
}) {

  return (
    <>
      <div className={`fv-row mb-10${parentClasses ? " " + parentClasses : ''}`}>
        <label className={`form-label-checkbox fs-6 fw-bolder text-dark${disabled ? " opacity-50" : ""}`}>
          {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
          <input
            className={`${classes ? " " + classes : ''}`}
            type="checkbox"
            {...register(name)}
            disabled={disabled}
            required={required}
          />
          <span className="checkmark"></span>
        </label>

        {errorMessage && (
          <div className="fv-plugins-message-container invalid-feedback">
            <div>{errorMessage}</div>
          </div>
        )}
      </div>
    </>
  );
}